/*
  Carrossel da VIGA: rolagem horizontal com encaixe, setas e barra de progresso.
  Estrutura da home da On (referência do Matheus, 16/10/2026). Serve aos
  Modelos agora e às vitrines e ao blog depois (doc 99 do vault).

  Marcação esperada:
  <viga-carrossel>
    <div class="viga-carrossel__trilho"> ...itens .viga-carrossel__item... </div>
    <div class="viga-carrossel__controles">
      <button class="viga-carrossel__seta" data-direcao="-1">…</button>
      <button class="viga-carrossel__seta" data-direcao="1">…</button>
      <div class="viga-carrossel__barra"><span class="viga-carrossel__barra-preenchida"></span></div>
    </div>
  </viga-carrossel>
*/
if (!customElements.get('viga-carrossel')) {
  customElements.define(
    'viga-carrossel',
    class VigaCarrossel extends HTMLElement {
      connectedCallback() {
        this.trilho = this.querySelector('.viga-carrossel__trilho');
        this.setas = this.querySelectorAll('.viga-carrossel__seta');
        this.preenchida = this.querySelector('.viga-carrossel__barra-preenchida');
        if (!this.trilho) return;
        this.atualizar = this.atualizar.bind(this);
        this.setas.forEach((seta) =>
          seta.addEventListener('click', () => this.andar(Number(seta.dataset.direcao)))
        );
        this.trilho.addEventListener('scroll', this.atualizar, { passive: true });
        window.addEventListener('resize', this.atualizar);
        this.atualizar();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.atualizar);
      }

      passo() {
        const item = this.trilho.querySelector('.viga-carrossel__item');
        if (!item) return this.trilho.clientWidth;
        const vao = parseFloat(getComputedStyle(this.trilho).columnGap) || 0;
        const porTela = Math.max(1, Math.floor((this.trilho.clientWidth + vao) / (item.offsetWidth + vao)));
        return porTela * (item.offsetWidth + vao);
      }

      andar(direcao) {
        this.trilho.scrollBy({ left: direcao * this.passo(), behavior: 'smooth' });
      }

      atualizar() {
        const { scrollLeft, scrollWidth, clientWidth } = this.trilho;
        const max = Math.max(0, scrollWidth - clientWidth);
        if (this.preenchida) {
          const visivel = scrollWidth ? clientWidth / scrollWidth : 1;
          const posicao = max ? scrollLeft / max : 0;
          this.preenchida.style.width = `${Math.min(100, visivel * 100)}%`;
          this.preenchida.style.left = `${posicao * (100 - Math.min(100, visivel * 100))}%`;
        }
        const [anterior, proxima] = this.setas;
        if (anterior) anterior.disabled = scrollLeft <= 1;
        if (proxima) proxima.disabled = scrollLeft >= max - 1;
        this.classList.toggle('viga-carrossel--sem-rolagem', max <= 1);
      }
    }
  );
}
